<template>
  <div class="expand-container">
    <Scrollbar style='height: 100%;width: 100%' ref="Scrollbar">
      <div class="messageManagement global_content">
          <div class="backImg cursor" @click="$router.go(-1)">
            <img src="@/assets/images/back.png" alt="">
            <span>返回</span>
          </div>
          <div class="messageManagement-content-box">
            <div class="mark"><span class="title">教学督导</span><span class="inner">Learning Supervisor</span></div>
            <div class="teacherInner">
              <img class="teacher-img" :src="teacher.headImg" alt="">
              <div class="teacher-info">
                <div><span class="teacher-info-label name">姓名：</span>{{teacher.realName}}</div>
                <div><span class="teacher-info-label phone">手机号：</span>{{teacher.cellPhone}}</div>
              </div>
            </div>
            <div class="mark"><span class="title">留言记录</span><span class="inner">Message record</span></div>
            <div class="box-inner">
              <div class="messageList">
                <div class="messageTitleId">ID</div>
                <div class="messagePeople">信息发送人</div>
                <div class="messageContent">信息内容</div>
              </div>
              <div class="messageInnerList" id="contentText">
                <div v-for="(item,index) in messageList" class="messageInner">
                  <div class="line1"></div>
                  <div class="line2"></div>
                  <div class="message-info messageTitleId idInner">
                    <span class="inner-text">
                      {{ item.id }}
                      <img v-if="!item.readSate" src="@/assets/images/ui-side/side-new.png" class="newMessage" alt=""></span>
                    </div>
                  <div class="message-info messagePeople sendPeople">
                    <div>
                      <span v-show="item.type == 0">学生：</span>
                      <span v-show="item.type == 1">督导：</span>{{ item.name }}
                    </div>
                    <div v-show="item.type == 0"><span>班级：</span>{{ item.className || '暂无班级'}}</div>
                    <div v-show="item.type == 1"><span>用户名：</span>{{ item.name}}</div>
                    <div><span>发表时间：</span>{{ item.createTime }}</div>
                  </div>
                  <div class="message-info messageContent sendInner" v-html="item.guestText"></div>
                </div>
              </div>
            </div>
            <paginationComponent class="pagination" @currentChange="currentChange" :currentPage="page" :pageSize="pageSize" :total="total"></paginationComponent>
            <div class="mark"><span class="title">留言</span><span class="inner">Leaving a message.</span></div>
            <UEdit v-model="contentText" placeholder="请填入详情内容" class="edit" ref="UEdit"></UEdit>
            <div class="button-inner">
            <el-button class="button" round @click="$router.go(-1)">取消</el-button>
            <el-button class="button" type="primary" round @click="pushLeaveAMessage()">保存</el-button>
          </div>
          </div>
      </div>
    </Scrollbar>
  </div>
</template>

<script>
import MyNav from '@/components/nav/SwitchIndex.vue'; // nav
import paginationComponent from '@components/paginationComponent/paginationComponent';
import UEdit from '@components/UEdit/UEdit';
import { Scrollbar } from 'element-ui';

const portrait = require('@/assets/images/default-portrait.png')

export default {
  name: 'messageManagement',
  components: {
    MyNav,
    UEdit,
    paginationComponent,
    Scrollbar,
  },
  watch: {
    messageList: {
      handler(value) {
        // 如果 item 存在表明是 列表来到详情
        this.$nextTick(() => {
          const zipImg = document.querySelector('#contentText').querySelectorAll('.downImgEditor');
          for (let i = 0; i < zipImg.length; i++) {
            const a = document.createElement('a');
            const img = zipImg[i];
            let downUrl = img.previousSibling.innerHTML; const url = downUrl;
            downUrl = downUrl.split('/');
            a.setAttribute('href', img.previousSibling.innerHTML);
            a.innerHTML = downUrl[downUrl.length - 1];
            const suffix = url.substr(url.lastIndexOf('.') + 1);
            img.setAttribute('onclick', `downUpload(this,'${suffix}','${img.previousSibling.innerHTML}')`);
            img.setAttribute('class', 'cursor');
            img.setAttribute('alt', '点击下载该附件');
            if (suffix != 'jpg' && suffix != 'png') {

              img.parentNode.insertBefore(a, img);
            }
          }
          // 留言进入需要定位置浏览器底部
          if (this.isFirst) {
            if (this.type == 2) {
              this.$refs.Scrollbar.wrap.scrollTop = document.querySelector('.messageManagement-content-box').scrollHeight;
            } else {
              this.$refs.Scrollbar.wrap.scrollTop = document.querySelector('.messageManagement-content-box').scrollHeight - 500;
            }
          }
        });
      },
    },
  },
  data() {
    return {
      type: 1,
      messageList: [],
      page: 1,
      pageSize: 10,
      total: 10,
      contentText: '',
      teacher: {
        realName: '',
        cellPhone: '',
        headImg: '',
      },
      isFirst: true,
    };
  },
  methods: {
    pushLeaveAMessage() {
      if (!this.contentText) {
        this.$message.warning('请写入留言内容');
        return false;
      }
      const loading = this.$loading({ text: '提交中...' });
      window.$axios.post('/ebopo/api/guestBook/publish', {
        guestText: this.contentText,
      })
        .then((res) => {
          if (!res.data.code) {
            // 更新留言列表
            this.getMessageList();
            this.contentText = '';
          }
          loading.close();
        }).catch((e) => {
          loading.close();
        });
    },
    currentChange(val) {
      // 切换分页时 不传递 type
      this.isFirst = false;
      this.page = val;
      this.getMessageList();
    },
    // 获取留言列表
    getMessageList() {
      const param = {};
      param.page = this.page;
      param.pageSize = this.pageSize;
      if (this.isFirst) {
        param.type = this.type;
      }
      window.$axios.get('/ebopo/api/guestBook/getDetailList', param)
        .then((res) => {

          if (!res.data.code) {
            this.messageList = res.data.data || [];
            // 如果 获取数据刚好为空 再次请求当前页
            if (!this.messageList.length && res.data.currentPage != 1 && res.data.currentPage != 0) {
              this.page = res.data.currentPage - 1;
              this.currentChange();
            } else {
              this.total = res.data.total;
              this.page = res.data.currentPage;
            }
          }
        });
    },
    getTeacher() {
      window.$axios.get('/ebopo/api/guestBook/getTeacher')
        .then((res) => {

          res = res.data;
          if (!res.data.code) {
            this.teacher.realName = res.data.realName || '暂无';
            this.teacher.cellPhone = res.data.cellPhone || '暂无';
            this.teacher.headImg = res.data.headImg || portrait;
          }
        });
    },
  },
  mounted() {
    // type 2 查看 1 留言  默认查看
    this.type = this.$route.query.type || 1;
    this.getMessageList();
    this.getTeacher();
  },
};
</script>

<style scoped lang="stylus">
.expand-container {
  height: 100%
  overflow hidden
}
.messageManagement-box {
   height 100%
 }
.messageManagement {
  height 100%
  .messageManagement-content-box {
    width: 100%
    padding 0 10px
    box-sizing border-box
  }
  .title {
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1884FF;
    line-height: 25px;
  }

  .inner {
    margin-left 8px
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1884FF;
    line-height: 20px;
  }

  .teacherInner {
    margin 0 auto
    width: 100%;
    box-sizing border-box
    height: 184px;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 2px #E2EBF3;
    border-radius: 18px;
    padding 32px
    .teacher-img {
      width: 120px
      height: 120px
      display block
      float left
    }
    .teacher-info {
      float left
      margin-left 7.5%
      padding-top 28px
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #202020;
      .teacher-info-label {
        width: 104px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        display inline-block
        &.name {
          padding-bottom 20px
        }
      }
    }
  }
  .box-inner {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 2px #E2EBF3;
    border-radius: 18px;
  }
  .messageList {
    width: 100%;
    height auto
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 2px #E2EBF3;
    border-radius: 18px;
  }

  .pagination {
    padding-top 25px
    text-align center
  }

  .messageInner {
    width: 100%
    box-sizing border-box
    border-top 1px solid #EEEEEE;
    overflow hidden
    position relative
    &:hover {
      background-color #f1f1f1
    }
    .line1 {
      position absolute
      height: 100%
      width: 1px
      background #EEEEEE
      left 10%
      top 0
    }
    .line2 {
      position absolute
      height: 100%
      width: 1px
      background #EEEEEE
      left 40%
      top 0
    }
    &:first-child {
      border-top-color transparent
    }
    .idInner {
      padding 20px 0
    }
    .sendPeople {
      padding 20px 40px
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
      box-sizing border-box
      span {
        color: #999999;
      }
    }
    .sendInner {
      padding 20px 40px
      box-sizing border-box
    }
  }
  .messageList {
    width: 100%;
    height: 44px;
    background: #1884FF;
    border-radius: 18px 18px 0px 0px;
    opacity: 0.4;
    box-sizing border-box
    padding-top 11px
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    overflow hidden
  }
  .messageTitleId {
    width: 10%
    float left
    text-align center
    position relative
    .inner-text {
      position relative
    }
    .newMessage {
      position absolute
      width: 29px
      height: 24px
      top: -10px;
      right: -32px;
      display: block;
    }
  }
  .messagePeople {
    width: 30%
    float left
    padding-left 40px;
    box-sizing border-box
  }
  .messageContent {
    width: 60%
    float left
    padding-left 40px;
    box-sizing border-box
  }
  .edit {
    width: 100%
  }
}

.global_content {
  margin: 0 auto
}
.mark {
  padding-bottom 16px
  padding-top 24px
}
.button-inner {
  padding-top 24px
  width: 100%
  text-align right
  padding-bottom 74px
  .button {
    width: 160px;
    height: 40px;
    border-radius: 20px;
  }
}
.backImg {
  overflow hidden
  padding-top 33px
  img {
    width: 24px
    height: 24px
    float: left;
  }
  span {
    margin-left 12px
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1884FF;
    float: left;
  }
}
/deep/.el-scrollbar__wrap {
  overflow hidden
  overflow-y scroll
}
</style>
